// Tagi marketingowe oddziałów/użytkowników ładowane tylko dla wejść z linku afiliacyjnego
// (?s= / ?sel_code=). Kod jest zapamiętywany przez SellerCodeReader, więc tagi działają też
// przy kolejnych wizytach bez parametru w URL. Wszystkie wymagają zgody marketingowej.
// Dodanie/zmiana tagów dla kodu = dopisanie/zmiana wpisu poniżej (klucz wielkimi literami);
// pole można pominąć, jeśli oddział nie ma danego tagu.
//   metaPixelId    — ID Meta (Facebook) Pixel
//   gtmContainerId — ID kontenera Google Tag Manager (GTM-XXXXXXX)
const TRACKING_BY_SELLER_CODE = {
    O43: {
        metaPixelId: "1753832818879624",
        gtmContainerId: "GTM-PC6WJDBQ",
    },
    D162: {
        metaPixelId: "1753832818879624",
        gtmContainerId: "GTM-PC6WJDBQ",
    },
};

export function getSellerTracking(sellerCode) {
    if (!sellerCode) {
        return {};
    }

    return TRACKING_BY_SELLER_CODE[sellerCode.toUpperCase()] || {};
}
